// @ts-nocheck
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import React from 'react';
import './FormField.css';

export function FormField({ label, hint, children, required }) {
  return (
    <div className="form-field">
      {label && (
        <label className="form-label">
          {label}
          {required && <span className="form-required">*</span>}
          {hint && <span className="form-hint"> - {hint}</span>}
        </label>
      )}
      {children}
    </div>
  );
}

export function Input({ label, hint, value, onChange, placeholder, type = 'text', required, disabled }) {
  return (
    <FormField label={label} hint={hint} required={required}>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className="form-input"
      />
    </FormField>
  );
}

export function Textarea({ label, hint, value, onChange, placeholder, rows = 4, required }) {
  return (
    <FormField label={label} hint={hint} required={required}>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className="form-textarea"
      />
    </FormField>
  );
}

export function Checkbox({ label, checked, onChange }) {
  return (
    <label className="resume-checkbox">
  <input
    type="checkbox"
    checked={checked}
    onChange={(e) => onChange(e.target.checked)}
    className="resume-checkbox-input"
  />
  <span className="resume-checkbox-label">{label}</span>
</label>
  );
}

export function Grid({ cols = 2, children }) {
  return (
    <div className="form-grid" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
      {children}
    </div>
  );
}

export function AtsTip({ title, tip }) {
  return (
    <div className="ats-tip">
      <div className="ats-tip-title"><LightbulbOutlinedIcon fontSize="inherit" /> {title}</div>
      <div className="ats-tip-text">{tip}</div>
    </div>
  );
}

export function SectionCard({ title, children, onRemove, showRemove, index }) {
  return (
    <div className="section-card">
      <div className="section-card-header">
        <span className="section-card-title">
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 20, height: 20, borderRadius: '50%', background: '#e2e8f0', fontSize: 10, fontWeight: 700, color: '#475569', flexShrink: 0 }}>{index + 1}</span>
          {title}
        </span>
        {showRemove && (
          <button className="section-card-remove" onClick={onRemove}>
            Remove
          </button>
        )}
      </div>
      <div className="section-card-body">{children}</div>
    </div>
  );
}

export function AddButton({ onClick, label }) {
  return (
    <button className="add-btn" onClick={onClick}>
      <span className="add-btn-icon">+</span>
      {label}
    </button>
  );
}

export function FormNav({ onBack, onNext, showBack, showNext, nextLabel = 'Next →', onPreview, isLast }) {
  return (
    <div className="form-nav">
      {showBack ? (
        <button className="form-nav-btn form-nav-btn--back" onClick={onBack}>
          ← Back
        </button>
      ) : <div />}
      <div className="form-nav-right">
        {isLast ? (
          <button className="form-nav-btn form-nav-btn--preview" onClick={onPreview}>
            <VisibilityOutlinedIcon fontSize="inherit" /> Preview Resume
          </button>
        ) : (
          <button className="form-nav-btn form-nav-btn--next" onClick={onNext}>
            {nextLabel}
          </button>
        )}
      </div>
    </div>
  );
}

export function FormSection({ title, children }) {
  return (
    <div className="form-section">
      <h3 className="form-section-title">{title}</h3>
      {children}
    </div>
  );
}

